import React from 'react';
import MyText from './MyText';

export default function Input(props){
    const isReadOnly = props.readOnly ? props.readOnly : false;
    return(
        <div style={{...styles.container, ...props.containerStyle}}>
            <MyText style={{...styles.label, ...props.labelStyle}}>{props.label}</MyText>
            <input readOnly={isReadOnly} type="text" value={props.value} onChange={props.onChange} maxLength={props.maxLength}
            style={{...styles.input, ...props.inputStyle}}/>
        </div>
    );
};
const styles = {
    container:{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    label:{
        fontSize: '1.2rem',
    },
    input:{
        // width: '100%',
        height: 30,
        borderRadius: 10,
        border: 'none',
        padding: '0.5rem 1rem',
        boxShadow: '0px 4px 4px 0px #0000000D',
        backgroundColor: 'white',
    }
}